export default {
  SAC_1: {
    title: 'Transiciones por Estado de Atención',
    description: 'Tabla con el total de transiciones realizadas entre los estados de atención en el período de tiempo seleccionado.',
  },
  SAC_2: {
    title: 'Línea de Tiempo de Publicaciones Propias',
    description: 'Lista ordenada por fecha (más reciente) de las publicaciones realizadas por los perfiles registrados (incluye publicaciones e interacciones de las páginas).',
  },
  SAC_3: {
    title: 'Engagement Recibido',
    description: 'Suma de todas las acciones de engagement recibidas a partir de publicaciones propias filtradas en la investigación.',
  },
  SAC_4: {
    title: 'Me Gusta Recibidos',
    description: 'Suma de todos los me gusta recibidos a partir de publicaciones propias filtradas en la investigación.',
  },
  SAC_5: {
    title: 'Comentarios Recibidos',
    description: 'Suma de todos los comentarios recibidos a partir de publicaciones propias realizadas en el período seleccionado y filtradas en la investigación.',
    info: {
      title: '¿Por qué este número es diferente de las Métricas Propietarias?',
      intro: 'Este componente suma los comentarios de las publicaciones de su marca — Publicaciones propietarias, Story y Reels — en todas las redes conectadas a la investigación. Las Métricas Propietarias muestran una red a la vez, como Instagram.',
      type: 'Dos filtros también cambian el resultado: Interacciones en "Indiferente" incluye interacciones de terceros, como menciones.',
      status: 'Estado se aplica a elementos de atención. Al usarlo, incluso con "Seleccionar todos", las publicaciones de su marca salen de la suma.',
      compare: 'Para comparar los dos números, use el mismo período, la misma página y la misma red social. Deje Estado sin selección y, en Interacciones, seleccione solo Publicaciones propietarias, Story y Reels.',
    },
  },
  SAC_6: {
    title: 'Publicaciones e Interacciones',
    description: 'Recuento de publicaciones de las páginas conectadas y filtradas en la investigación. Muestra publicaciones propias de forma predeterminada, pero puede ajustarse para mostrar todos los tipos de interacción.',
  },
  SAC_7: {
    title: 'Impresiones',
    description: 'Suma del total de impresiones orgánicas y pagadas a partir de publicaciones propias filtradas en la investigación.',
  },
  SAC_8: {
    title: 'Alcance',
    description: 'Suma del total de alcance logrado a partir de publicaciones propias filtradas en la investigación.',
  },
  SAC_9: {
    title: 'Vistas',
    description: 'Suma de las visualizaciones de video en los canales propios de la investigación.',
  },
  SAC_10: {
    title: 'Impresiones en el Tiempo',
    description: 'Suma del total de impresiones a partir de publicaciones propias filtradas en la investigación, distribuida en el período de tiempo seleccionado. En Instagram, solo las Historias devuelven este dato, por limitación de Meta.',
  },
  SAC_11: {
    title: 'Alcance en el Tiempo',
    description: 'Suma del total de alcance logrado a partir de publicaciones propias filtradas en la investigación, distribuida en el período de tiempo seleccionado.',
  },
  SAC_12: {
    title: 'Engagement Recibido en el Tiempo',
    description: 'Suma de todas las acciones de engagement recibidas a partir de publicaciones propias filtradas en la investigación, distribuida en el período de tiempo seleccionado.',
  },
  SAC_13: {
    title: 'Publicaciones con Más Engagement',
    description: 'Tarjetas en forma de lista con contenido propio ordenado por el total de engagement obtenido.',
  },
  SAC_14: {
    title: 'Sentimiento de las Interacciones en el Tiempo',
    description: 'Distribución de las interacciones recibidas por su polaridad a lo largo de un período de tiempo.',
  },
  SAC_15: {
    title: 'Termómetro de Sentimiento de las Interacciones',
    description: 'Representa el resultado de la ecuación: (publicaciones positivas / publicaciones recopiladas * 100) - (publicaciones negativas / publicaciones recopiladas * 100), aplicada solo a las interacciones recibidas.',
  },
  SAC_16: {
    title: 'Engagement por Canal en el Tiempo',
    description: 'Distribución de las interacciones recibidas divididas por canal propio a lo largo de un período de tiempo.',
  },
  SAC_17: {
    title: 'Usuarios Interactuando',
    description: 'Recuento de usuarios únicos que interactuaron con los canales propios.',
  },
  SAC_18: {
    title: 'Sentimiento por Canal Propio',
    description: 'Distribución de publicaciones (posts + interacciones) por canales propios y su desglose por polaridad.',
  },
  SAC_19: {
    title: 'Sentimiento por Etiqueta Propia',
    description: 'Distribución de publicaciones (posts + interacciones) por etiquetas asignadas y su desglose por polaridad.',
  },
  SAC_20: {
    title: 'Sentimiento de las Interacciones por Género',
    description: 'Distribución de interacciones por género y su desglose por polaridad.',
  },
  SAC_21: {
    title: 'Sentimiento por Temas',
    description: 'Distribución de publicaciones (posts + interacciones) por temas de la investigación y su desglose por polaridad.',
  },
  SAC_22: {
    title: 'Distribución de Sentimiento de las Interacciones',
    description: 'División de las interacciones por polaridad positiva, negativa o neutra.',
  },
  SAC_23: {
    title: 'Publicaciones Propias Más Comentadas',
    description: 'Tarjetas en forma de carrusel con contenido propio ordenado por el total de comentarios recibidos.',
  },
  SAC_24: {
    title: 'Interacciones por Canal',
    description: 'Distribución del volumen de interacciones recibidas divididas por canal propio.',
  },
  SAC_25: {
    title: 'Interacciones por Usuario',
    description: 'Razón entre el número de interacciones dividido por la cantidad de usuarios interactuando.',
  },
  SAC_26: {
    title: 'Sentimiento de las Interacciones en el Tiempo (Porcentaje)',
    description: 'Distribución de las interacciones recibidas por proporción porcentual de positivas, negativas y neutras a lo largo de un período de tiempo.',
  },
  SAC_27: {
    title: 'Atenciones por Operadores',
    description: 'Distribución porcentual del volumen de atenciones realizadas por cada operador.',
  },
  SAC_28: {
    title: 'Usuarios con Más de 1 Interacción',
    description: 'Número total de usuarios que interactuaron más de una vez con el contenido propio.',
  },
  SAC_29: {
    title: 'Distribución por Tema (Propio)',
    description: 'Volumen de publicaciones o interacciones en perfiles propios distribuidas por temas registrados en la investigación.',
  },
  SAC_30: {
    title: 'Distribución por Etiqueta (Propio)',
    description: 'Volumen de publicaciones o interacciones en perfiles propios distribuidas por etiquetas asignadas.',
  },
  SAC_31: {
    title: 'Total de Fans',
    description: 'Total de fans de las páginas seleccionadas en la fecha final del período investigado.',
  },
  SAC_32: {
    title: 'Nuevos Fans',
    description: 'Total de fans ganados por las páginas seleccionadas en el período investigado.',
  },
  SAC_33: {
    title: 'Evolución de la Base de Fans',
    description: 'Variación diaria de fans de las páginas investigadas en el período, relativa al día anterior.',
  },
  SAC_34: {
    title: 'Matriz de Engagement por Publicaciones',
    description: 'Compara el engagement, las impresiones y el índice de sentimiento de los comentarios en publicaciones propias. La división de cuadrantes se basa en el promedio aritmético de los últimos 90 días.',
  },
  SAC_35: {
    title: 'Matriz de Engagement por Etiquetas',
    description: 'Compara el engagement, las impresiones y el índice de sentimiento de los comentarios de publicaciones, por etiqueta. La división de cuadrantes se basa en el promedio aritmético de los últimos 90 días.',
  },
  SAC_36: {
    title: 'Volumen de Atenciones por Operador',
    description: 'Total de eventos contabilizados entre "Estado Anterior" y "Estado Nuevo", filtrados por operador. No contabiliza conversaciones pendientes nuevas sin cambio de estado.',
  },
  SAC_37: {
    title: 'Volumen de Atenciones por Página',
    description: 'Total de eventos contabilizados entre "Estado Anterior" y "Estado Nuevo", filtrados por página. No contabiliza conversaciones pendientes nuevas sin cambio de estado.',
  },
  SAC_38: {
    title: 'Volumen de Atenciones en el Tiempo',
    description: 'Total de eventos contabilizados entre "Estado Anterior" y "Estado Nuevo", filtrados en el tiempo. No contabiliza conversaciones pendientes nuevas sin cambio de estado.',
  },
  SAC_39: {
    title: 'Total de Atenciones',
    description: 'Total de eventos contabilizados entre "Estado Anterior" y "Estado Nuevo" filtrados en la investigación. (Nota: No contabiliza conversaciones pendientes nuevas donde aún no ha ocurrido cambio de estado.)',
  },
  SAC_40: {
    title: 'Tiempo Promedio de Atención por Operador',
    description: 'Tiempo promedio transcurrido entre "Estado Anterior" y "Estado Nuevo" filtrados en la investigación, por operador.',
  },
  SAC_41: {
    title: 'Tiempo Promedio de Atención por Página',
    description: 'Tiempo promedio transcurrido entre "Estado Anterior" y "Estado Nuevo" filtrados en la investigación, por página.',
  },
  SAC_42: {
    title: 'Tiempo Promedio de Atención en el Tiempo',
    description: 'Tiempo promedio transcurrido entre "Estado Anterior" y "Estado Nuevo" filtrados en la investigación, en el tiempo.',
  },
  SAC_43: {
    title: 'Tiempo Promedio de Atención Total',
    description: 'Tiempo promedio transcurrido entre "Estado Anterior" y "Estado Nuevo" filtrados en la investigación.',
  },
  SAC_44: {
    title: 'Atenciones por Operadores en el Tiempo',
  },
  SAC_45: {
    title: 'Informe de Operadores',
    description: 'Informe de registros de actividad de los operadores.',
  },
  SAC_46: {
    title: 'Informe de Productividad',
    description: 'Informe de productividad.',
  },
  SAC_47: {
    title: 'Tabla de Backlog',
    description: 'Tabla de los casos abiertos más antiguos.',
  },
  SAC_48: {
    title: 'SLA',
    description: 'Conversaciones respondidas dentro del SLA.',
  },
  SAC_49: {
    title: 'Productividad',
    description: 'Métrica de evaluación del desempeño de las atenciones realizadas por los operadores en relación con los casos recibidos. Representa el resultado de la ecuación (total de atenciones / total de casos recibidos * 100).',
  },
  SAC_50: {
    title: 'Productividad por Día',
    description: 'Distribución del índice de productividad por día a lo largo del tiempo. Mide la evaluación del desempeño de las atenciones realizadas por los operadores en relación con los casos recibidos.',
  },
  SAC_51: {
    title: 'Volumen de Atenciones Recibidas vs. Atendidas',
    description: 'Número de atenciones recibidas en comparación con las atendidas a lo largo del tiempo.',
  },
  SAC_52: {
    title: 'Estado de los Operadores',
    description: 'Tabla que muestra el estado de atención de todos los operadores.',
  },
  SAC_53: {
    title: 'Evaluaciones Consolidadas',
    description: 'Muestra los resultados de la encuesta de satisfacción del cliente por sentimiento.',
  },
  SAC_54: {
    title: 'Evaluaciones en el Tiempo',
    description: 'Muestra los resultados de la encuesta de satisfacción del cliente.',
  },
  SAC_55: {
    title: 'Evaluaciones de Atención',
    description: 'Tabla con las evaluaciones de atención realizadas vía Smartcare.',
  },
  SAC_56: {
    title: 'Tabla de Lovers',
    description: 'Tabla de usuarios más comprometidos.',
  },
  SAC_57: {
    title: 'Intereses de los Lovers',
    description: 'Distribución de intereses encontrados en las publicaciones de los usuarios.',
  },
  SAC_58: {
    title: 'Tiempo Promedio de Atención',
    description: 'Tiempo en cada estado de la conversación.',
  },
  SAC_59: {
    title: 'Matriz de Rendimiento de Usuarios',
    description: 'Matriz de rendimiento de los usuarios, detallando el horario de actuación de cada operador.',
  },
  SAC_60: {
    title: 'Cantidad de Atenciones por Canal',
    description: 'Tabla con la cantidad de atenciones dividida por canales.',
  },
  SAC_61: {
    title: 'Publicaciones por Etiqueta',
    description: 'Distribución de publicaciones por etiquetas asignadas para datos propios.',
  },
  SAC_62: {
    title: 'Publicaciones por Etiqueta en el Tiempo',
    description: 'Distribución de publicaciones por etiquetas asignadas en la investigación a lo largo del tiempo.',
  },
  SAC_63: {
    title: 'Interacciones en el Tiempo',
    description: 'Distribución lineal de las interacciones recopiladas a lo largo de un período de tiempo.',
  },
  SAC_64: {
    title: 'Publicaciones por Etiqueta',
    description: 'Distribución de publicaciones por etiquetas asignadas.',
  },
  SAC_65: {
    title: 'Proyección de Muestreo de Publicaciones',
    description: 'Proyección del volumen de publicaciones recopiladas en el período investigado, considerando el muestreo de publicaciones.',
  },
  SAC_66: {
    title: 'Evaluaciones en Google Mi Negocio',
    description: 'Cantidad de evaluaciones por número de estrellas en el canal Google Mi Negocio.',
  },
  SAC_67: {
    title: 'Interacciones enrutadas a lo largo del tiempo',
    description: 'Distribución de las interacciones por configuración de enrutamiento a lo largo del tiempo.',
  },
};
